import { app } from '../../../app';
import { Controller } from './device-management.controller';

app.component('userDevices', {
    bindings: {
        account: '<',
        devices: '<',
    },
    controller: Controller,
    templateUrl: require('./device-management.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/device-management/device-management.component.js